import React from 'react';
import './RegisterPage.css';
import { register, clearError } from '../../redux/authentication/authentication_actions';
import { connect } from 'react-redux';
import logoImage from '../../assets/images/2e-building.png';

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordRetype: '',
      email: '',
      firstName: '',
      lastName: '',
      validatingPassword: false,
      validatingEmail: false,
    };
    this.handleBlurPassword = this.handleBlurPassword.bind(this);
    this.handleBlurEmail = this.handleBlurEmail.bind(this);
  }

  onRegisterSubmit() {
    const { password, passwordRetype, email, firstName, lastName } = this.state;
    var username = email;
    if (!username || !password || !passwordRetype || !email) return;
    if (password !== passwordRetype) return;
    if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) return;
    this.props.register(username, password, passwordRetype, email, firstName, lastName);
  }

  onValueChange(event, fieldName) {
    this.setState({ ...this.state, [fieldName]: event.target.value });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isRegistering && !this.props.errorMessage) {
      this.props.history.push('/register/success/');
    }
  }

  backToLogin() {
    this.props.history.push('/');
  }

  handleBlurPassword() {
    if (this.state.password != "" && this.state.passwordRetype != "") {
      this.setState({ validatingPassword: true });
    }
  }

  handleBlurEmail() {
    this.setState({ validatingEmail: true });
  }

  renderPasswordConfirmError() {
    if (this.state.validatingPassword && this.state.password !== this.state.passwordRetype && this.state.password != "" && this.state.passwordRetype != "") {
      return true
    }  
    return false;
  }

  renderEmailConfirmError() {
    if (this.state.validatingEmail && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.email)) {
      return true
    }  
    return false;
  }

  componentDidMount() {
    this.props.clearError();
  }

  render() {
    const { isRegistering, errorMessage } = this.props;

    return (
      <div className="zenregister scrollable-container">
        <div className="register-container">
          <div className="register-header">
            <img style={{ width: '100%' }} src={logoImage} />
            <a style={{ fontSize: 20, paddingTop: 10 }} href="#">Building Energy Code</a>
          </div>

          <div className="register-content">
            <form
              className="user-register-form"
              onSubmit={() => this.onRegisterSubmit()}
            >
              

              <div
                className="form-actions form-group js-form-wrapper form-wrapper"
              >
                <button
                  onClick={this.backToLogin.bind(this)}
                  type="button"
                  className="button btn icon-before"
                >
                  <span
                    className="icon glyphicon glyphicon glyphicon-menu-left"
                    aria-hidden="true"
                  />
                  Back to login
                </button>
              </div>

              <div className="form-item js-form-item form-type-textfield js-form-type-textfield form-item-name js-form-item-name form-group">
                <label
                  htmlFor="edit-email"
                  className="control-label js-form-required form-required"
                >
                  Email *
                </label>
                <input
                  autoCorrect="none"
                  autoCapitalize="none"
                  spellCheck="false"
                  className="form-text required form-control"
                  id="edit-email"
                  name="email"
                  value={this.state.email}
                  size="60"
                  maxLength="60"
                  type="text"
                  onChange={event => this.onValueChange(event, 'email')}
                  onBlur={this.handleBlurEmail}
                  disabled={isRegistering}
                  required
                />
              </div>

              <div className="form-item js-form-item form-type-password js-form-type-password form-item-pass js-form-item-pass form-group">
                <label
                  htmlFor="edit-pass"
                  className="control-label js-form-required form-required"
                >
                  Password *
                </label>
                <input
                  className="form-text required form-control"
                  id="edit-pass"
                  name="pass"
                  size="60"
                  maxLength="128"
                  type="password"
                  value={this.state.password}
                  onChange={event => this.onValueChange(event, 'password')}
                  onBlur={this.handleBlurPassword}
                  disabled={isRegistering}
                  required
                />
              </div>

              <div className="form-item js-form-item form-type-password js-form-type-password form-item-pass js-form-item-pass form-group">
                <label
                  htmlFor="edit-pass-retype"
                  className="control-label js-form-required form-required"
                >
                  Password (Re-type) *
                </label>
                <input
                  className="form-text required form-control"
                  id="edit-pass-retype"
                  name="pass-retype"
                  size="60"
                  maxLength="128"
                  type="password"
                  value={this.state.passwordRetype}
                  onChange={event => this.onValueChange(event, 'passwordRetype')}
                  onBlur={this.handleBlurPassword}
                  disabled={isRegistering}
                  required
                />
              </div>

              <div className="form-item js-form-item form-type-textfield js-form-type-textfield form-item-name js-form-item-name form-group">
                <label
                  htmlFor="edit-firstName"
                  className="control-label js-form-required form-required"
                >
                  First Name
                </label>
                <input
                  autoCorrect="none"
                  autoCapitalize="none"
                  className="form-text required form-control"
                  id="edit-firstName"
                  name="name"
                  value={this.state.firstName}
                  size="60"
                  maxLength="60"
                  type="text"
                  onChange={event => this.onValueChange(event, 'firstName')}
                  disabled={isRegistering}
                />
              </div>

              <div className="form-item js-form-item form-type-textfield js-form-type-textfield form-item-name js-form-item-name form-group">
                <label
                  htmlFor="edit-lastName"
                  className="control-label js-form-required form-required"
                >
                  Last Name
                </label>
                <input
                  autoCorrect="none"
                  autoCapitalize="none"
                  className="form-text required form-control"
                  id="edit-lastName"
                  name="name"
                  value={this.state.lastName}
                  size="60"
                  maxLength="60"
                  type="text"
                  onChange={event => this.onValueChange(event, 'lastName')}
                  disabled={isRegistering}
                />
              </div>

              {this.renderPasswordConfirmError() ? (
                <div className="alert alert-danger" id="edit-password-not-match" >Passwords do not match</div>
              ) : null}

              {this.renderEmailConfirmError() ? (
                <div className="alert alert-danger" id="edit-email-wrong-pattern" >Email address is invalid</div>
              ) : null}

              {errorMessage ? (
                <div className="alert alert-danger" id="edit-invalid" >{errorMessage}</div>
              ) : null}

              <div
                className="form-actions form-group js-form-wrapper form-wrapper"
              >
                <button
                  onClick={this.onRegisterSubmit.bind(this)}
                  type="submit"
                  className="button js-form-submit form-submit btn-primary btn icon-before"
                  id="edit-submit"
                  disabled={isRegistering || this.renderPasswordConfirmError() || this.renderEmailConfirmError() }
                >
                  <span
                    className="icon glyphicon glyphicon-log-in"
                    aria-hidden="true"
                  />
                  {isRegistering ? 'Registering...' : 'Register'}
                </button>
              </div>
            </form>
          </div>

          <div className="register-footer">
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.authentication.errorMessage,
  isRegistering: state.authentication.registering,
});

const mapDispatchToProps = dispatch => ({
  register: (...args) => dispatch(register(...args)),
  clearError: (...args) => dispatch(clearError(...args)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisterPage);



// WEBPACK FOOTER //
// ./src/pages/register/RegisterPage.js